import styled from 'styled-components';
import { Table, FovButton } from 'components/generic';
import { getColor } from 'utils';
import constants from 'constants/index';

const light = constants.THEME.LIGHT;

export const MemberContainer = styled(Table)`
    border: 0.0625rem solid #ccc;
    border-radius: 0.25rem;
    border-color: ${props => getColor(props, 'mediumGrey')};
`;

export const MemberSection = styled('div')`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem;
    background-color: ${props => !props.isOdd ? getColor(props, 'bgCellOdd') : getColor(props, 'bgCell')};
    height: 100%;

    border-bottom: 0.0625rem solid #eee;
    border-color: ${props => getColor(props, 'mediumGrey')};
    &:last-child: {
        border-bottom: none;
    }
`;

export const HeaderSection = styled(MemberSection)`
    background-color: ${props => getColor(props, 'mediumGrey')};
`;

export const NameContainer = styled('div')`
    padding-right: 0.5rem;
    width: 18rem;
`;

export const IconButton = styled(FovButton)`
    width: fit-content;
    padding: 0;
    background-color: ${props => getColor(props, 'primary')};
    color: ${props => getColor(props, 'onPrimary')};

    &:hover {
       background-color: ${props => {
        const lightTheme = props.$selectedTheme === light;
        return getColor(props, lightTheme ? 'mediumGrey' : 'accent');
       }};
    }
`;

export const LoginAsButton = styled('button')`
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    padding: 0.25rem 0.6rem;
    font-size: 0.75rem;
    font-weight: 500;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    border-radius: 1rem;
    transition: all 0.15s ease;
    border: 0.0625rem solid ${props => props.theme.hexToRgba(getColor(props, 'accent'), 0.4)};
    color: ${props => getColor(props, 'accent')};
    background-color: ${props => props.theme.hexToRgba(
        getColor(props, 'accent'), props.$selectedTheme === light ? 0.08 : 0.14)};

    svg { display: block; }
    svg path { fill: currentColor; }

    &:hover:not(:disabled) {
        color: ${props => getColor(props, 'onAccent')};
        border-color: ${props => getColor(props, 'accent')};
        background-color: ${props => getColor(props, 'accent')};
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.45;
    }
`;

export const ColumnContainer = styled('div')`
    position: relative;
    display: inline-flex;
    width: 10rem;
    margin-right: 5rem;
    margin-left: 5rem;

    &:first-child {
       margin-left: auto;
    }

    &:last-child {
       margin-left: auto;
    }
`;

export const SelectionBar = styled('div')`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.5rem 0.75rem;
    border-radius: 0.25rem;
    background-color: ${props => getColor(props, 'mediumGrey')};
    color: ${props => getColor(props, 'onPrimary')};
`;


export const CountContainer = styled('div')`
    display: flex;
    align-items: center;
`;

export const RoleHeaderContainer = styled('div')`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    white-space: nowrap;
`;

export const RoleHeaderLabel = styled('span')`
    color: ${props => getColor(props, 'onPrimary')};
`;

export const RoleFilterWrapper = styled('div')`
    position: relative;
    display: inline-flex;
    align-items: center;

    &::after {
        content: '▾';
        position: absolute;
        right: 0.4rem;
        pointer-events: none;
        font-size: 0.75rem;
        color: inherit;
    }
`;

export const RoleFilterSelect = styled('select')`
    appearance: none;
    border: 0.0625rem solid ${props => getColor(props, 'mediumGrey')};
    border-radius: 0.25rem;
    background: transparent;
    color: ${props => getColor(props, 'onPrimary')};
    color-scheme: ${props => props.$selectedTheme === light ? 'light' : 'dark'};
    padding: 0.2rem 1.5rem 0.2rem 0.5rem;
    cursor: pointer;
    font-size: 0.875rem;
    min-width: 7.5rem;

    option {
        background-color: ${props => getColor(props, props.$selectedTheme === light ? 'white' : 'darkGrey')};
        color: ${props => getColor(props, 'onPrimary')};
    }

    &:focus-visible {
        outline: none;
        box-shadow: 0 0 0.1rem 0.1rem ${props => getColor(props, 'accent')};
    }
`;

export const ColumnSortSelect = styled(RoleFilterSelect)`
    min-width: 0;
    padding: 0.2rem 1.25rem 0.2rem 0.4rem;
`;

export const ConnectionBadge = styled('span')`
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    font-size: 0.75rem;
    font-weight: 500;
    padding: 0.2rem 0.55rem;
    border-radius: 1rem;
    white-space: nowrap;
    background-color: ${props => props.$connected
        ? props.theme.hexToRgba(props.theme.colors[props.$selectedTheme || 'dark'].success, 0.15)
        : props.theme.hexToRgba(props.theme.colors[props.$selectedTheme || 'dark'].onPrimary, 0.1)};
    color: ${props => props.$connected
        ? getColor(props, 'success')
        : props.theme.hexToRgba(props.theme.colors[props.$selectedTheme || 'dark'].onPrimary, 0.5)};

    &::before {
        content: '';
        display: inline-block;
        width: 0.45rem;
        height: 0.45rem;
        border-radius: 50%;
        background-color: currentColor;
        flex-shrink: 0;
    }
`;

export const AddButton = styled(FovButton)`
  position: relative;
  width: fit-content;
  cursor: pointer;
  background-color: ${props => getColor(props, 'accent')};
  margin-right: 0;
  margin-left: auto;
  color: ${props => getColor(props, 'onPrimary')};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  flex-shrink: 0;
  &:hover {
    background-color: ${props => getColor(props, 'accentHover')};
  }
`;